<template>
  <router-view name="unused"> </router-view>
</template>

<script setup lang="ts">
import router from "./router";

const { currentRoute } = router;

// The purpose of this control is to ensure routing is initialized on views
// which do not actually use it.
// This is to support the ?team=blahdeblah functionality.
</script>
